import React, { createContext, useEffect } from 'react'
import { HotSearchModule } from './HotSearch/HotSearchModule'
import { SearchHistory } from './SearchHistory/SearchHistory'
import { SearchInput } from './SearchInput/SearchInput'
import { SearchModel } from './searchModel'
import {reducer, defaultState} from './reducer'

declare const Session: any
export const Context = createContext(null)

function SearchPage() {
    const [state, dispatch] = React.useReducer(reducer, defaultState)
    const [init, setInit] = React.useState<boolean>(false)

    useEffect(() => {

        if (Session.weixinApi) {
            Session.weixinApi.initJSSDK()

            const shareData = {
                link: window.location.origin + window.location.pathname + window.location.search
            }

            const timeShareData = {
                ...shareData,
                link: `https://share.lizhiweike.com${window.location.pathname}${window.location.search}`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])
        }

        SearchModel.fetchSearchResult().then((res) => {
            if (res) {
                dispatch({
                    type: 'GET_SEARCH_CONFIG',
                    payload: res
                })
                setInit(true)
            }
        })
    }, [])

    if (!init) {
        return null
    }

    return (
        <Context.Provider value={{state, dispatch}}>
            <div style={{ minHeight: '100vh', background: '#fff'}}>
                <SearchInput/>
                <SearchHistory/>
                <HotSearchModule/>
            </div>
        </Context.Provider>
    )
}

export default SearchPage



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/HomeSearchPage.tsx